import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";
import {SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "./semantic_search_amplitude_location";

export type AmplitudeAiQuestionType = "suggested" | "custom";

interface ITrackAmplitudeSubmitAiQuestionParams {
    modalSize: AmplitudeSemanticSearchModalSize | null;
    analyticSessionId: string | null | undefined;
    questionType: AmplitudeAiQuestionType;
    questionHeading: string;
}

export const trackAmplitudeSubmitAiQuestion = ({modalSize, analyticSessionId, questionType, questionHeading}: ITrackAmplitudeSubmitAiQuestionParams) => {
    trackAmplitudeEvent("submit_ai_question", {
        analytic_session_id: analyticSessionId ?? null,
        modal_size: modalSize,
        location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION,
        question_type: questionType,
        question_heading: questionHeading
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";
import {SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "./semantic_search_amplitude_location";

export type AmplitudeAiQuestionType = "suggested" | "custom";

interface ITrackAmplitudeSubmitAiQuestionParams {
    modalSize: AmplitudeSemanticSearchModalSize | null;
    analyticSessionId: string | null | undefined;
    questionType: AmplitudeAiQuestionType;
    questionHeading: string;
}

export const trackAmplitudeSubmitAiQuestion = ({modalSize, analyticSessionId, questionType, questionHeading}: ITrackAmplitudeSubmitAiQuestionParams) => {
    trackAmplitudeEvent("submit_ai_question", {
        analytic_session_id: analyticSessionId ?? null,
        modal_size: modalSize,
        location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION,
        question_type: questionType,
        question_heading: questionHeading
    });
};
